var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLimsInfographic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 402.44 259.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-2 {\n        font-family: Calibri, Calibri;\n        font-size: 9.26px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #0c344a;\n      }\n\n      .cls-4 {\n        letter-spacing: 0em;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-7 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-10, .cls-11 {\n        fill: #fff;\n      }\n\n      .cls-12 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-13 {\n        letter-spacing: 0em;\n      }\n\n      .cls-14 {\n        letter-spacing: .02em;\n      }\n\n      .cls-15 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-16 {\n        letter-spacing: .05em;\n      }\n\n      .cls-17 {\n        letter-spacing: 0em;\n      }\n\n      .cls-18 {\n        letter-spacing: 0em;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-21 {\n        letter-spacing: .01em;\n      }\n\n      .cls-22 {\n        letter-spacing: .03em;\n      }\n\n      .cls-23 {\n        letter-spacing: .16em;\n      }\n\n      .cls-24 {\n        letter-spacing: 0em;\n      }\n\n      .cls-25 {\n        letter-spacing: .03em;\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-28 {\n        letter-spacing: .03em;\n      }\n\n      .cls-11, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34 {\n        fill-rule: evenodd;\n      }\n\n      .cls-35 {\n        letter-spacing: .11em;\n      }\n\n      .cls-36 {\n        letter-spacing: 0em;\n      }\n\n      .cls-29 {\n        fill: #6d66d2;\n      }\n\n      .cls-37 {\n        letter-spacing: 0em;\n      }\n\n      .cls-38 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-39 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        font-family: Calibri-Bold, Calibri;\n        font-size: 10.29px;\n        font-weight: 700;\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-41 {\n        letter-spacing: 0em;\n      }\n\n      .cls-42 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-30 {\n        fill: #4caefd;\n      }\n\n      .cls-43 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-45 {\n        letter-spacing: .02em;\n      }\n\n      .cls-46 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-48 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-49 {\n        letter-spacing: .16em;\n      }\n\n      .cls-50 {\n        letter-spacing: .02em;\n      }\n\n      .cls-51 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-52 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-53 {\n        letter-spacing: 0em;\n      }\n\n      .cls-54 {\n        letter-spacing: 0em;\n      }\n\n      .cls-55 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-56 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-57 {\n        letter-spacing: 0em;\n      }\n\n      .cls-58 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-59 {\n        letter-spacing: 0em;\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-61 {\n        letter-spacing: 0em;\n      }\n\n      .cls-62 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-63 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-64 {\n        letter-spacing: 0em;\n      }\n\n      .cls-65 {\n        letter-spacing: 0em;\n      }\n\n      .cls-66 {\n        letter-spacing: 0em;\n      }\n\n      .cls-67 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-68 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-69 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-70 {\n        letter-spacing: 0em;\n      }\n\n      .cls-71 {\n        letter-spacing: .02em;\n      }\n\n      .cls-72 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-73 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-74 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-75 {\n        letter-spacing: 0em;\n      }\n\n      .cls-76 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-77 {\n        letter-spacing: .01em;\n      }\n\n      .cls-78 {\n        letter-spacing: 0em;\n      }\n\n      .cls-31 {\n        fill: #846cfa;\n      }\n\n      .cls-79 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-80 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-81 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-32 {\n        fill: #71c7fe;\n      }\n\n      .cls-82 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-83 {\n        letter-spacing: .02em;\n      }\n\n      .cls-84 {\n        letter-spacing: 0em;\n      }\n\n      .cls-85 {\n        letter-spacing: .02em;\n      }\n\n      .cls-86 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-87 {\n        letter-spacing: 0em;\n      }\n\n      .cls-88 {\n        letter-spacing: .01em;\n      }\n\n      .cls-89 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-90 {\n        letter-spacing: 0em;\n      }\n\n      .cls-91 {\n        letter-spacing: .02em;\n      }\n\n      .cls-92 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-93 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-94 {\n        letter-spacing: .01em;\n      }\n\n      .cls-95 {\n        letter-spacing: .02em;\n      }\n\n      .cls-96 {\n        letter-spacing: 0em;\n      }\n\n      .cls-97 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-98 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-99 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-100 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-101 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-102 {\n        letter-spacing: 0em;\n      }\n\n      .cls-103 {\n        letter-spacing: 0em;\n      }\n\n      .cls-104 {\n        letter-spacing: 0em;\n      }\n\n      .cls-105 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-106 {\n        letter-spacing: 0em;\n      }\n\n      .cls-107 {\n        clip-rule: evenodd;\n      }\n\n      .cls-107, .cls-108 {\n        fill: none;\n      }\n\n      .cls-109 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-110 {\n        letter-spacing: 0em;\n      }\n\n      .cls-111 {\n        letter-spacing: 0em;\n      }\n\n      .cls-112 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-113 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-114 {\n        letter-spacing: 0em;\n      }\n\n      .cls-115 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-116 {\n        letter-spacing: .03em;\n      }\n\n      .cls-117 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-118 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-119 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-120 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-121 {\n        letter-spacing: .11em;\n      }\n\n      .cls-122 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-123 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-124 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-33 {\n        fill: #717dfb;\n      }\n\n      .cls-125 {\n        clip-path: url(#clippath-55);\n      }\n\n      .cls-126 {\n        letter-spacing: 0em;\n      }\n\n      .cls-127 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-128 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-129 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-130 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-131 {\n        letter-spacing: .05em;\n      }\n\n      .cls-132 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-133 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-134 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-135 {\n        letter-spacing: .01em;\n      }\n\n      .cls-136 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-137 {\n        letter-spacing: .01em;\n      }\n\n      .cls-138 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-139 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-140 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-141 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-142 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-143 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-34 {\n        fill: #efefef;\n      }\n\n      .cls-144 {\n        letter-spacing: 0em;\n      }\n\n      .cls-145 {\n        letter-spacing: .02em;\n      }\n\n      .cls-146 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-147 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-148 {\n        letter-spacing: 0em;\n      }\n\n      .cls-149 {\n        letter-spacing: .02em;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 158.05,
    y: 23.4,
    width: 86.34,
    height: 59.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "158.05 82.54 244.39 82.54 244.39 23.4 158.05 23.4 158.05 82.54 158.05 82.54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 158.05,
    y: 23.4,
    width: 86.34,
    height: 59.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "158.05 82.54 244.39 82.54 244.39 23.4 158.05 23.4 158.05 82.54 158.05 82.54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 158.05,
    y: 23.4,
    width: 86.34,
    height: 59.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "158.05 82.54 244.39 82.54 244.39 23.4 158.05 23.4 158.05 82.54 158.05 82.54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 158.05,
    y: 23.4,
    width: 86.34,
    height: 59.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 8.38,
    y: 78.43,
    width: 85.83,
    height: 54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "8.38 132.43 94.21 132.43 94.21 78.43 8.38 78.43 8.38 132.43 8.38 132.43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 8.38,
    y: 78.43,
    width: 85.83,
    height: 54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "8.38 132.43 94.21 132.43 94.21 78.43 8.38 78.43 8.38 132.43 8.38 132.43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 8.38,
    y: 78.43,
    width: 85.83,
    height: 54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "8.38 132.43 94.21 132.43 94.21 78.43 8.38 78.43 8.38 132.43 8.38 132.43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 8.38,
    y: 78.43,
    width: 85.83,
    height: 54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 66.63,
    y: 158.36,
    width: 98.02,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "66.63 212.87 164.65 212.87 164.65 158.36 66.63 158.36 66.63 212.87 66.63 212.87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 66.63,
    y: 158.36,
    width: 98.02,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "66.63 212.87 164.65 212.87 164.65 158.36 66.63 158.36 66.63 212.87 66.63 212.87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 66.63,
    y: 158.36,
    width: 98.02,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "66.63 212.87 164.65 212.87 164.65 158.36 66.63 158.36 66.63 212.87 66.63 212.87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 66.63,
    y: 158.36,
    width: 98.02,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 163.03,
    y: 188.41,
    width: 86.34,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "163.03 242.93 249.36 242.93 249.36 188.41 163.03 188.41 163.03 242.93 163.03 242.93"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 163.03,
    y: 188.41,
    width: 86.34,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "163.03 242.93 249.36 242.93 249.36 188.41 163.03 188.41 163.03 242.93 163.03 242.93"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 163.03,
    y: 188.41,
    width: 86.34,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "163.03 242.93 249.36 242.93 249.36 188.41 163.03 188.41 163.03 242.93 163.03 242.93"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 163.03,
    y: 188.41,
    width: 86.34,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "163.03 242.93 249.36 242.93 249.36 188.41 163.03 188.41 163.03 242.93 163.03 242.93"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 163.03,
    y: 188.41,
    width: 86.34,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "163.03 242.93 249.36 242.93 249.36 188.41 163.03 188.41 163.03 242.93 163.03 242.93"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 163.03,
    y: 188.41,
    width: 86.34,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 259.78,
    y: 161.16,
    width: 82.28,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "259.78 215.67 342.05 215.67 342.05 161.16 259.78 161.16 259.78 215.67 259.78 215.67"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 259.78,
    y: 161.16,
    width: 82.28,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "259.78 215.67 342.05 215.67 342.05 161.16 259.78 161.16 259.78 215.67 259.78 215.67"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 259.78,
    y: 161.16,
    width: 82.28,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "259.78 215.67 342.05 215.67 342.05 161.16 259.78 161.16 259.78 215.67 259.78 215.67"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 259.78,
    y: 161.16,
    width: 82.28,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 320.16,
    y: 72.51,
    width: 82.28,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "320.16 127.03 402.44 127.03 402.44 72.51 320.16 72.51 320.16 127.03 320.16 127.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 320.16,
    y: 72.51,
    width: 82.28,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "320.16 127.03 402.44 127.03 402.44 72.51 320.16 72.51 320.16 127.03 320.16 127.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 320.16,
    y: 72.51,
    width: 82.28,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "320.16 127.03 402.44 127.03 402.44 72.51 320.16 72.51 320.16 127.03 320.16 127.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 320.16,
    y: 72.51,
    width: 82.28,
    height: 54.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "93.46 95.83 118.35 95.83 118.35 70.63 93.46 70.63 93.46 95.83 93.46 95.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "93.46 95.83 118.35 95.83 118.35 70.63 93.46 70.63 93.46 95.83 93.46 95.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "129.63 146.89 154.52 146.89 154.52 121.69 129.63 121.69 129.63 146.89 129.63 146.89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "129.63 146.89 154.52 146.89 154.52 121.69 129.63 121.69 129.63 146.89 129.63 146.89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "188.78 166.89 213.66 166.89 213.66 141.69 188.78 141.69 188.78 166.89 188.78 166.89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "188.78 166.89 213.66 166.89 213.66 141.69 188.78 141.69 188.78 166.89 188.78 166.89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "247.33 147.34 272.22 147.34 272.22 122.14 247.33 122.14 247.33 147.34 247.33 147.34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "247.33 147.34 272.22 147.34 272.22 122.14 247.33 122.14 247.33 147.34 247.33 147.34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "285.21 96.94 310.1 96.94 310.1 71.74 285.21 71.74 285.21 96.94 285.21 96.94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "285.21 96.94 310.1 96.94 310.1 71.74 285.21 71.74 285.21 96.94 285.21 96.94"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M18.1,143.57C9.62,126.16,3.67,107.67,.39,88.52c-2.77-16.14,9.51-30.92,25.75-30.92H107.08c25.32,0,35.85,32.69,15.37,47.71l-65.49,48.01c-13.14,9.63-31.69,4.96-38.85-9.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M295.36,57.6h80.94c16.24,0,28.52,14.78,25.75,30.92-3.28,19.15-9.23,37.64-17.71,55.05-7.16,14.71-25.71,19.38-38.85,9.75l-65.49-48.01c-20.48-15.02-9.96-47.71,15.37-47.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M274.64,112.65l65.34,48.12c13.12,9.66,14.46,28.98,2.81,40.41-6.79,6.66-14.04,12.85-21.71,18.53-7.83,5.8-16.03,11-24.53,15.58-14.34,7.73-32.09,.49-37.11-15.17l-24.97-77.89c-7.81-24.37,19.71-44.64,40.16-29.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M201.05,259.14c-9.64,0-19.21-.67-28.67-2.01-16.12-2.28-26.3-18.66-21.27-34.26l25.04-77.62c7.84-24.29,41.96-24.29,49.79,0l25.04,77.62c5.03,15.6-5.14,31.98-21.27,34.26-9.45,1.34-19.03,2.01-28.67,2.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M142.59,220.13c-5.02,15.66-22.77,22.9-37.11,15.17-8.5-4.58-16.69-9.78-24.53-15.58-7.67-5.68-14.92-11.87-21.71-18.53-11.65-11.43-10.3-30.75,2.81-40.41l65.34-48.12c20.45-15.06,47.98,5.21,40.16,29.58l-24.97,77.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M221.94,154.29c0,11.65-9.32,21.09-20.82,21.09s-20.82-9.44-20.82-21.09,9.32-21.09,20.82-21.09,20.82,9.44,20.82,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M280.34,134.74c0,11.65-9.21,21.09-20.57,21.09s-20.57-9.44-20.57-21.09,9.21-21.09,20.57-21.09,20.57,9.44,20.57,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M316.91,84.34c0,11.65-9.32,21.09-20.82,21.09s-20.82-9.44-20.82-21.09,9.32-21.09,20.82-21.09,20.82,9.44,20.82,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M126.97,84.34c0,11.65-9.32,21.09-20.82,21.09s-20.82-9.44-20.82-21.09,9.32-21.09,20.82-21.09,20.82,9.44,20.82,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M163.03,134.74c0,11.65-9.21,21.09-20.57,21.09s-20.57-9.44-20.57-21.09,9.21-21.09,20.57-21.09,20.57,9.44,20.57,21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M221.94,110.54c-.88,0-1.66-.57-1.93-1.43-.34-1.06,.18-2.19,1.18-2.58,9.34-3.65,17.62-9.82,23.92-17.83,.38-.48,.95-.76,1.56-.76,.43,0,.84,.14,1.19,.4,.45,.34,.74,.83,.81,1.4,.07,.57-.08,1.14-.44,1.59-6.75,8.56-15.59,15.16-25.55,19.07-.24,.09-.48,.14-.73,.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M249.86,87.26c-.43,0-.83-.13-1.18-.39-.87-.64-1.1-1.84-.51-2.74,5.47-8.41,8.62-18.17,9.1-28.23,.05-1.07,.93-1.9,2.01-1.9,.58,0,1.1,.22,1.48,.63,.39,.41,.59,.96,.56,1.53-.53,10.74-3.91,21.18-9.77,30.19-.38,.58-1.01,.93-1.7,.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M201.07,114.12c-5.32,0-10.62-.71-15.72-2.1-.54-.15-.99-.5-1.26-1-.26-.49-.32-1.06-.14-1.59,.28-.86,1.04-1.42,1.91-1.42,.17,0,.35,.02,.52,.07,4.77,1.3,9.71,1.96,14.7,1.96s9.93-.66,14.7-1.96c.17-.05,.35-.07,.52-.07,.87,0,1.63,.56,1.9,1.4,.18,.55,.13,1.12-.14,1.61-.27,.5-.71,.85-1.26,1-5.11,1.39-10.4,2.1-15.72,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M152.15,87.27c-.69,0-1.32-.35-1.7-.93-5.86-9.01-9.24-19.44-9.77-30.19-.03-.57,.17-1.12,.56-1.53,.38-.4,.9-.63,1.45-.63,1.1,0,1.99,.84,2.04,1.9,.49,10.06,3.64,19.82,9.1,28.24,.58,.9,.36,2.1-.51,2.74l-.04,.03c-.31,.23-.72,.36-1.14,.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M180.12,110.55c-.25,0-.5-.05-.73-.14-9.97-3.91-18.81-10.51-25.55-19.07-.35-.45-.51-1.02-.44-1.59,.07-.57,.36-1.06,.81-1.4,.35-.26,.76-.4,1.19-.4,.61,0,1.18,.28,1.56,.76,6.3,8.02,14.57,14.18,23.92,17.83,1,.39,1.52,1.52,1.18,2.57-.27,.87-1.05,1.45-1.93,1.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M253.43,52.97c0,29.26-23.42,52.97-52.31,52.97s-52.31-23.72-52.31-52.97S172.23,0,201.12,0s52.31,23.72,52.31,52.97h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(172.46 36.46) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-95",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-94",
    x: 5.65,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 11.3,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 14.91,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-146",
    x: 20.05,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 22.11,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 25.2,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-126",
    x: 30.35,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-104",
    x: 35.49,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 39.09,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 44.74,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 48.34,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 53.49,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.6,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(165.86 48.8) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 0,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 5.65,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-144",
    x: 9.26,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 11.83,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-103",
    x: 16.46,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 19.02,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 24.68,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-85",
    x: 29.31,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 31.87,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 37.52,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 41.13,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 46.27,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-102",
    x: 50.39,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 52.96,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-102",
    x: 57.07,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-94",
    x: 59.64,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-137",
    x: 65.29,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 70.95,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(167.38 61.15) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-96",
    x: 0,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 5.14,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-146",
    x: 16.45,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 18.5,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-94",
    x: 22.62,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 28.28,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 36.51,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-102",
    x: 42.16,
    y: 0
  }, "li"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-126",
    x: 47.3,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 52.44,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 58.09,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 62.21,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 67.36,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(165.35 73.49) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-103",
    x: 0,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 2.57,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-146",
    x: 8.22,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-103",
    x: 10.28,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-96",
    x: 12.85,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 17.98,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-145",
    x: 23.64,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-144",
    x: 26.2,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-94",
    x: 33.91,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 39.56,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 43.16,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-144",
    x: 48.31,
    y: 0
  }, "fl"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-88",
    x: 54.05,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-144",
    x: 59.7,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 67.41,
    y: 0
  }, "s"))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(14.67 90.06) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 0,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 5.66,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 10.28,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 13.89,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 15.94,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 20.06,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 24.69,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 27.78,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 31.38,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 34.47,
    y: 0
  }, "ud"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 43.73,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 45.79,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 50.42,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 54.02,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    x: 56.08,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(14.67 101.37) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-134",
    x: 0,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 7.2,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-122",
    x: 11.82,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 16.45,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 21.07,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 25.19,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 29.81,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 32.9,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 37.52,
    y: 0
  }, "pp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 46.78,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 49.87,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 55.01,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-83",
    x: 59.12,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 63.74,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 65.8,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 69.41,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    x: 71.47,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(14.67 112.69) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 0,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 4.62,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 9.26,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 12.35,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 17.49,
    y: 0
  }, "ll"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 21.61,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-148",
    x: 24.17,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 27.77,
    y: 0
  }, "ub"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 37.04,
    y: 0
  }, "j"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 39.09,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-149",
    x: 43.72,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 47.83,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 50.92,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 54.52,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 56.58,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(14.67 123.99) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 0,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-122",
    x: 4.62,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-131",
    x: 13.88,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 16.45,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 20.05,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 24.16,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 28.79,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 33.42,
    y: 0
  }, "du"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 42.68,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 44.74,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-121",
    x: 49.36,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 52.45,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-83",
    x: 55.54,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 60.16,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 63.76,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 67.88,
    y: 0
  }, "s"))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(72.81 170.3) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-135",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 4.62,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 7.71,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 12.33,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-70",
    x: 16.44,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 20.55,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 22.62,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 27.25,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 32.39,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 35.99,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 38.05,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 42.69,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 46.8,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 48.86,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 52.46,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 54.51,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 59.66,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 63.77,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(72.81 181.61) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 0,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 3.6,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 8.22,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 11.31,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 15.93,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-84",
    x: 19.02,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-110",
    x: 23.14,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 25.2,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 29.83,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 33.94,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 38.57,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 43.2,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 46.29,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 49.89,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-121",
    x: 51.95,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 55.04,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 59.66,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.92,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(72.81 192.92) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 0,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 4.62,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 9.26,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 12.86,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 17.49,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 20.58,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 25.2,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 28.29,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 32.92,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 36.01,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 41.15,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 44.24,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-149",
    x: 49.38,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 53.49,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 58.63,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 60.69,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(72.81 204.24) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 0,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-122",
    x: 4.62,
    y: 0
  }, "dh"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 13.88,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 18.51,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 21.6,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 26.22,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 30.85,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.96,
    y: 0
  }, "e"))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(169.15 200.48) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-134",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 7.72,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-122",
    x: 12.86,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 17.49,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 19.55,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.64,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 27.79,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-131",
    x: 30.87,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 33.44,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 38.07,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 42.7,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 47.31,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 49.37,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 52.47,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.1,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(169.15 211.8) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 0,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 4.63,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 9.25,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 12.34,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 16.96,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 19.03,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 23.65,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 32.91,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 35.48,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 40.11,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 44.73,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-83",
    x: 49.36,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 53.98,
    y: 0
  }, "vi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 60.16,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 65.3,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 68.39,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 71.99,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(169.15 223.12) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 0,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 6.68,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 8.74,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 11.83,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 16.47,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 19.03,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 22.12,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 26.74,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.36,
    y: 0
  }, "l"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(202.15 223.12) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(205.2 223.12) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 0,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-132",
    x: 5.09,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 12.29,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.92,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(169.15 234.42) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 0,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 4.63,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 9.25,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 12.85,
    y: 0
  }, "hb"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 22.12,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 27.26,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 31.88,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-122",
    x: 34.97,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.6,
    y: 0
  }, "s"))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(265.74 173.09) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 0,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 5.67,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 10.28,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 19.55,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 21.61,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 26.23,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 29.32,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 33.95,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-149",
    x: 38.57,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 42.68,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 45.77,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 50.91,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 55.54,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 59.15,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 63.26,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    x: 65.32,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(265.74 184.41) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 0,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 4.63,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 6.69,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 10.29,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 13.39,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 18.53,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 20.59,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 25.73,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-84",
    x: 29.84,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 33.96,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-121",
    x: 36.02,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 39.1,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 43.72,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.99,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(265.74 195.72) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 0,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 3.09,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-122",
    x: 7.71,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 12.35,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 17.49,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 20.57,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 25.67,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 30.3,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 34.42,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 38.01,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 44.69,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 46.75,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 49.84,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 54.47,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(265.74 207.04) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 0,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-149",
    x: 2.56,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 8.73,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-100",
    x: 14.4,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 19.54,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 25.71,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-131",
    x: 31.37,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 33.94,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 37.54,
    y: 0
  }, "upp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 51.44,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 56.58,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 59.66,
    y: 0
  }, "t"))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(326.13 84.58) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 0,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 5.66,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 7.72,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 11.83,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 13.89,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 16.99,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 21.61,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-131",
    x: 23.66,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 26.23,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 29.83,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 31.89,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 36.01,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 40.64,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 45.26,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 48.35,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 52.98,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 56.07,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 60.7,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 64.3,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    x: 66.36,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(326.13 95.9) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 0,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-122",
    x: 4.62,
    y: 0
  }, "ud"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 13.88,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 15.94,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-131",
    x: 19.03,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 21.6,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 24.69,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 27.78,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 32.4,
    y: 0
  }, "il"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 36.52,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 40.12,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-121",
    x: 42.18,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 45.26,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 49.88,
    y: 0
  }, "nd"), /*#__PURE__*/React.createElement("tspan", {
    x: 59.15,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(326.13 107.2) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 0,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 3.09,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 7.71,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 11.83,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 16.46,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 18.52,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 23.14,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 26.23,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 31.37,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-84",
    x: 34.46,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.58,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(326.13 118.52) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 0,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 4.11,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 8.74,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 13.37,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-70",
    x: 17.47,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 21.59,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 26.22,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 31.36,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 33.42,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 38.05,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 41.15,
    y: 0
  }, "s"))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M106.01,92.69h-9.63c-.21,0-.39-.18-.39-.39v-1.18h-.58c-.43,0-.78-.35-.78-.79v-.39c0-.43,.35-.79,.78-.79h.58v-1.18h-.58c-.43,0-.78-.35-.78-.79v-.39c0-.43,.35-.79,.78-.79h.58v-1.18h-.58c-.43,0-.78-.35-.78-.79v-.39c0-.43,.35-.79,.78-.79h.58v-1.18h-.58c-.43,0-.78-.35-.78-.79v-.39c0-.43,.35-.79,.78-.79h.58v-1.18h-.58c-.43,0-.78-.35-.78-.79v-.39c0-.43,.35-.79,.78-.79h.58v-1.18h-.58c-.43,0-.78-.35-.78-.79v-.39c0-.43,.35-.79,.78-.79h.58v-1.18c0-.22,.17-.39,.39-.39h14.78c.21,0,.39,.18,.39,.39v2.36h1.94c.21,0,.39,.18,.39,.39v1.58c0,.22-.17,.39-.39,.39h-1.94v.98h1.94c.21,0,.39,.18,.39,.39v1.58c0,.22-.17,.39-.39,.39h-1.94v1.77c-.06,0-.13,0-.19,0-.2,0-.39,0-.58,.03v-9.48h-14v.79h.58c.43,0,.78,.35,.78,.79v.39c0,.43-.35,.79-.78,.79h-.58v1.18h.58c.43,0,.78,.35,.78,.79v.39c0,.43-.35,.79-.78,.79h-.58v1.18h.58c.43,0,.78,.35,.78,.79v.39c0,.43-.35,.79-.78,.79h-.58v1.18h.58c.43,0,.78,.35,.78,.79v.39c0,.43-.35,.79-.78,.79h-.58v1.18h.58c.43,0,.78,.35,.78,.79v.39c0,.43-.35,.79-.78,.79h-.58v1.18h.58c.43,0,.78,.35,.78,.79v.39c0,.43-.35,.79-.78,.79h-.58v.79h8.75c.14,.27,.31,.54,.49,.79h0Zm5.54-13.19h1.56v-.79h-1.56v.79h0Zm-16.14-1.77h1.94v-.39h-1.94v.39h0Zm0,12.21v.39h1.94v-.39h-1.94Zm0-2.76h1.94v-.39h-1.94v.39h0Zm0-6.3h1.94v-.39h-1.94v.39h0Zm0,3.15h1.94v-.39h-1.94v.39h0Zm0-9.45h1.94v-.39h-1.94v.39h0Zm16.14,1.58h1.56v-.79h-1.56v.79h0Zm-2.92-.59v4.73c0,.22-.17,.39-.39,.39h-8.94c-.21,0-.39-.18-.39-.39v-4.73c0-.22,.17-.39,.39-.39h8.94c.21,0,.39,.18,.39,.39h0Zm-.78,.39h-8.17v3.94h8.17v-3.94h0Zm-7.19,1.58c-.21,0-.39-.18-.39-.39s.17-.39,.39-.39h6.22c.21,0,.39,.18,.39,.39s-.17,.39-.39,.39h-6.22Zm0,1.58c-.21,0-.39-.18-.39-.39s.17-.39,.39-.39h6.22c.21,0,.39,.18,.39,.39s-.17,.39-.39,.39h-6.22Zm10.7,3.74c3.22,0,5.83,2.65,5.83,5.91s-2.61,5.91-5.83,5.91-5.83-2.65-5.83-5.91,2.61-5.91,5.83-5.91h0Zm0,.79c-2.79,0-5.06,2.29-5.06,5.12s2.27,5.12,5.06,5.12,5.06-2.29,5.06-5.12-2.27-5.12-5.06-5.12h0Zm1.35,2.17v1.89l1.28,3.17c.15,.36,.11,.78-.11,1.11-.22,.33-.58,.52-.97,.52h-3.13c-.39,0-.75-.2-.97-.52-.22-.33-.26-.74-.11-1.11l1.28-3.17v-1.89h-.39c-.21,0-.39-.18-.39-.39s.17-.39,.39-.39h3.5c.21,0,.39,.18,.39,.39s-.17,.39-.39,.39h-.39Zm-1.94,0v1.97c0,.05,0,.1-.03,.15l-.42,1.03h2.06l-.42-1.03s-.03-.1-.03-.15v-1.97h-1.17Zm-.76,3.94l-.58,1.43c-.05,.12-.04,.26,.04,.37,.07,.11,.19,.17,.32,.17h3.13c.13,0,.25-.07,.32-.17,.07-.11,.09-.25,.04-.37l-.58-1.43h-2.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M153.35,135.86c.21,0,.39-.18,.39-.39v-12.6c0-.22-.17-.39-.39-.39h-22.55c-.21,0-.39,.18-.39,.39v12.6c0,.22,.17,.39,.39,.39h1.98c.08,.37,.26,.71,.52,.98-1.04,.42-1.72,1.43-1.72,2.56v1.97h-.78c-.21,0-.39,.18-.39,.39v1.58c0,.22,.17,.39,.39,.39h.78v1.97c0,.22,.17,.39,.39,.39h20.22c.21,0,.39-.18,.39-.39v-1.97h.78c.21,0,.39-.18,.39-.39v-1.58c0-.22-.17-.39-.39-.39h-2.72v-3.54c0-.65-.52-1.18-1.17-1.18h-6.22c-.64,0-1.16,.53-1.17,1.18v1.97h-1.94c-.21,0-.39,.18-.39,.39v.79c0,.13,.02,.27,.07,.39h-1.24v-1.97c0-1.13-.68-2.15-1.72-2.56,.26-.27,.44-.61,.52-.98h15.98Zm-1.56,9.45h-19.44v-1.58h19.44v1.58h0Zm-8.94-7.48c0-.22,.17-.39,.39-.39h6.22c.21,0,.39,.18,.39,.39v3.54h-7v-3.54h0Zm-2.33,2.76h1.56v.79h-1.17c-.21,0-.39-.18-.39-.39v-.39Zm12.44,1.58v.79h-21.78v-.79h21.78Zm-15.17-2.76v1.97h-5.44v-1.97c0-.93,.65-1.74,1.56-1.93v1.93c0,.1,.04,.2,.11,.28l.78,.79c.15,.15,.4,.15,.55,0l.78-.79c.07-.08,.11-.18,.11-.28v-1.93c.9,.19,1.55,.99,1.56,1.93h0Zm-1.98-5.11l.81,.28v.9c0,.65-.52,1.18-1.17,1.18h-.78c-.64,0-1.16-.53-1.17-1.18v-.84l2.3-.33h0Zm-2.29-.46c.03-.63,.54-1.12,1.16-1.12h.78c.58,0,1.07,.44,1.15,1.02l-.64-.22c-.06-.02-.12-.02-.18-.02l-2.27,.33Zm1.94,3.61v1.81l-.39,.39-.39-.39v-1.81h.78Zm0-5.51h-.78c-1.07,0-1.94,.88-1.94,1.97v1.18h-1.56v-11.81h21.78v11.81h-15.55v-1.18c0-1.09-.87-1.97-1.94-1.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M140.7,132.13c.41,0,.81-.17,1.1-.46l2.75-2.78c.61-.62,.61-1.61,0-2.23-.61-.62-1.59-.62-2.2,0l-2.75,2.78c-.61,.62-.61,1.61,0,2.23,.29,.29,.69,.46,1.1,.46h0Zm2.2-4.92c.3-.31,.8-.31,1.1,0,.3,.31,.3,.81,0,1.11l-1.1,1.11-1.1-1.11,1.1-1.11h0Zm-2.75,2.78l1.1-1.11,1.1,1.11-1.1,1.11c-.3,.31-.8,.31-1.1,0-.3-.31-.3-.81,0-1.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M142.08,134.29c2.79,0,5.06-2.29,5.06-5.12s-2.26-5.12-5.06-5.12-5.06,2.29-5.06,5.12c0,2.83,2.26,5.12,5.06,5.12h0Zm0-9.45c2.36,0,4.28,1.94,4.28,4.33s-1.92,4.33-4.28,4.33-4.28-1.94-4.28-4.33c0-2.39,1.92-4.33,4.28-4.33h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "145.96 139.01 146.74 139.01 146.74 139.8 145.96 139.8 145.96 139.01 145.96 139.01"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M200.86,156.41s.06,.06,.09,.08c.14,.11,.32,.04,.43-.08l1.6-1.62c.51-.52,.51-1.36,0-1.89-.49-.52-1.37-.52-1.86,0-1.25-1.21-3.05,.61-1.86,1.88l1.6,1.63Zm-1.22-3.12c.29-.31,.8-.31,1.09,0l.19,.2c.1,.11,.28,.11,.38,0l.19-.2c.74-.69,1.79,.35,1.09,1.1l-1.48,1.5-1.48-1.49c-.29-.31-.29-.8,0-1.11h0Zm10.97,.36h-4.56c-.35,0-.35-.55,0-.55h4.56c.35,0,.35,.55,0,.55h0Zm1.02-9.36h-20.8c-.33,0-.6,.28-.6,.61v12.6c0,.33,.27,.61,.6,.61h20.8c.33,0,.6-.28,.6-.61v-12.6c0-.33-.27-.61-.6-.61h0Zm-16.23,13.27h-3v-.69c0-.59,.35-1.13,.87-1.38,.4,.19,.87,.19,1.26,0,.52,.25,.87,.8,.87,1.38v.69Zm-1.5-4.33c1.37,.07,1.09,2.11-.25,1.81-1.01-.28-.8-1.8,.25-1.81h0Zm3.42,4.33h-1.37v-.69c0-.7-.36-1.37-.95-1.75,.82-.91,.12-2.46-1.1-2.43-1.22-.02-1.92,1.53-1.1,2.44-.58,.37-.95,1.03-.95,1.74v.69h-1.02s-.06-.02-.06-.06v-6.02h6.55v6.09h0Zm7.09,0h-6.54v-6.09h6.54v6.09h0Zm0-6.64h-13.63v-2.77h3.78c.12,0,.22-.07,.26-.19,0-.01,.18-.54,.34-1l.96,2.71c.08,.24,.44,.24,.52,0l.34-.99,.34,.99c.07,.24,.44,.25,.52,0l.97-2.72,.97,2.72c.04,.11,.14,.18,.26,.18s.22-.07,.26-.19l.53-1.56h3.62v2.82h0Zm0-3.36h-3.81c-.12,0-.22,.07-.26,.19l-.34,1-.96-2.71c-.04-.11-.14-.18-.26-.18s-.22,.07-.26,.18l-.96,2.71-.34-1c-.04-.11-.14-.19-.26-.19s-.22,.07-.26,.19l-.34,1-.96-2.71c-.04-.11-.14-.18-.26-.18s-.22,.07-.26,.19c-.31,.91-.46,1.35-.53,1.56h-3.58v-2.71s.02-.06,.06-.06h13.58v2.72h0Zm7.23,10h-6.69v-12.72h6.69s.06,.02,.06,.06c-.05,.09,.11,12.65-.06,12.66h0Zm-5.58-5.92h4.56c.35,0,.35,.55,0,.55h-4.56c-.36,0-.35-.55,0-.55h0Zm4.56,4.89h-4.56c-.35,0-.35-.55,0-.55h4.56c.35,0,.35,.55,0,.55h0Zm1.53-13.7h-21.82c-.84,0-1.53,.69-1.53,1.55v15.14c0,.85,.69,1.55,1.53,1.55h9.35v2.06h-1.59c-1.16,0-2.12,.89-2.26,2.03h-5.33c-.35,0-.36,.55,0,.55h21.47c.15,0,.27-.12,.27-.28s-.12-.28-.27-.28h-5.32c-.14-1.14-1.1-2.03-2.26-2.03h-1.58v-2.06h9.35c.84,0,1.53-.69,1.53-1.55v-15.14c0-.86-.69-1.55-1.53-1.55h0Zm-7.76,20.84c.86,0,1.58,.64,1.71,1.48h-9.72c.13-.84,.85-1.48,1.71-1.48h6.3Zm-4.17-.55v-2.06h2.03v2.06h-2.03Zm12.91-3.6c0,.55-.44,.99-.98,.99h-21.82c-.54,0-.98-.45-.98-.99v-15.14c0-.55,.44-.99,.98-.99h21.82c.54,0,.98,.45,.98,.99v15.14Zm-7.07-9.33h1.92c.35,0,.35,.55,0,.55h-1.92c-.35,0-.35-.55,0-.55h0Zm1.92-1.45c.35,0,.35,.55,0,.55h-1.92c-.35,0-.35-.55,0-.55h1.92Zm2.64,5.79c.35,0,.35,.55,0,.55h-4.56c-.35,0-.35-.55,0-.55h4.56Zm-4.56-6.68h3.83c.15,0,.27-.12,.27-.28v-1.45c0-.15-.12-.28-.27-.28h-3.83c-.15,0-.27,.12-.27,.28v1.45c0,.15,.12,.28,.27,.28h0Zm.27-1.45h3.29v.9h-3.29v-.9h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M255.49,140.73c0,.23-.18,.41-.41,.41s-.41-.18-.41-.41c0-.23,.18-.41,.41-.41,.23,0,.41,.18,.41,.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M265.69,134.95c3.25,.02,5.95-2.53,6.17-5.81,.22-3.28-2.12-6.17-5.34-6.6-3.22-.43-6.22,1.76-6.83,4.99-.62,3.23,1.35,6.39,4.5,7.22l-.87,4.74h-5.37c0-.6-.29-1.16-.79-1.49-.49-.33-1.12-.39-1.66-.16-.39,.16-.76,.38-1.1,.63-1.34-1.38-1.97-3.31-1.7-5.23,.01,.02,.02,.03,.04,.05,.42,.43,.99,.67,1.59,.66,.23,0,.46-.04,.68-.12l.76,.77c.32,.32,.84,.32,1.15,0l.58,.58c.48,.48,1.25,.48,1.73,0l.58-.58c.23-.23,.36-.55,.36-.88s-.13-.64-.36-.88l-.58-.58c.32-.32,.32-.85,0-1.17l-6.93-7.01c-.32-.32-.84-.32-1.15,0l-1.15-1.17c-.23-.23-.54-.36-.87-.36s-.64,.13-.87,.36l-.58,.58c-.23,.23-.36,.55-.36,.88s.13,.64,.36,.88l1.15,1.17c-.32,.32-.32,.85,0,1.17l1.78,1.8c-2.21,3.88-1.44,8.8,1.85,11.79-.16,.52-.24,1.06-.24,1.61v.45c-1.18,.2-2.04,1.23-2.04,2.44v.83h-.41c-.23,0-.41,.18-.41,.41s.18,.41,.41,.41h20.4c.23,0,.41-.18,.41-.41s-.18-.41-.41-.41h-.41v-.83c0-1.37-1.1-2.48-2.45-2.48h-9.38v-1.24h11.83c.45,0,.82-.37,.82-.83v-.83c0-.46-.37-.83-.82-.83h-5.63l.84-4.59c.24,.03,.47,.04,.71,.05h0Zm-17.54-10.57c0-.11,.04-.21,.12-.29l.58-.58c.08-.08,.18-.12,.29-.12s.21,.04,.29,.12l1.15,1.17-1.15,1.17-1.15-1.17c-.08-.08-.12-.18-.12-.29h0Zm5.17,8.33c-.56-.56-.56-1.48,0-2.04,.56-.56,1.46-.56,2.02,0,.56,.56,.56,1.48,0,2.04-.56,.56-1.46,.56-2.02,0h0Zm5.92,.73c.08,.08,.12,.18,.12,.29s-.04,.21-.12,.29l-.58,.58c-.08,.08-.18,.12-.29,.12s-.21-.04-.29-.12l-.58-.58,1.15-1.17,.58,.58h0Zm-7.5-8.76l6.92,7.01-.29,.29-1.73,1.75-.29,.29-.59-.6c.05-.04,.11-.08,.16-.13,.57-.57,.79-1.41,.58-2.2-.21-.78-.81-1.4-1.59-1.61-.77-.21-1.6,.01-2.17,.59-.05,.05-.09,.11-.13,.16l-3.19-3.23,2.31-2.34h0Zm-1.54,9.44c0-1.44,.36-2.85,1.03-4.12l.98,.99c-.11,.35-.14,.73-.08,1.09-.2,.66-.3,1.34-.3,2.03,0,1.83,.71,3.58,1.96,4.89-.39,.4-.72,.86-.97,1.36-1.67-1.64-2.62-3.9-2.61-6.26h0Zm18.77,11.58v.83h-17.95v-.83c0-.91,.73-1.65,1.63-1.65h14.69c.9,0,1.63,.74,1.63,1.65h0Zm-15.91-2.48v-.41c0-.55,.1-1.09,.29-1.61h0c.44-1.17,1.33-2.11,2.47-2.59,.29-.12,.63-.09,.89,.09,.26,.18,.42,.48,.42,.8v3.72h-4.08Zm16.73-2.07h-11.83v-.83h11.83v.83h0Zm-9.38-12.39c0-2.97,2.37-5.37,5.3-5.37s5.3,2.4,5.3,5.37-2.37,5.37-5.3,5.37c-2.93,0-5.3-2.41-5.3-5.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M266.82,130.19c.18-.06,.34-.16,.47-.3,.29-.3,.42-.72,.36-1.14-.01-.26-.01-.38,.12-.52,.13-.13,.25-.13,.51-.12,.41,.07,.83-.07,1.12-.36,.29-.3,.43-.72,.36-1.14,0-.23-.2-.41-.42-.4s-.4,.2-.39,.43c.01,.27,.01,.38-.12,.52-.13,.13-.24,.14-.51,.12-.41-.07-.83,.07-1.12,.36-.29,.3-.43,.72-.36,1.14,.01,.27,.01,.38-.12,.52-.1,.1-.25,.15-.39,.13-.66-.5-1.71-.34-2.45,.41-.8,.81-.92,1.98-.29,2.63,.28,.27,.66,.42,1.04,.41,.09,0,.17,0,.25-.02,.49-.08,.95-.32,1.3-.69,.54-.51,.78-1.26,.64-1.99h0Zm-1.21,1.4c-.23,.24-.52,.4-.84,.45-.21,.04-.44-.02-.6-.16-.31-.32-.18-.99,.29-1.46,.47-.48,1.13-.61,1.44-.29,.31,.32,.18,.98-.29,1.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M266.51,126.69c0-1.14-.91-2.07-2.04-2.07s-2.04,.92-2.04,2.07,.91,2.07,2.04,2.07c1.13,0,2.04-.93,2.04-2.07h0Zm-3.26,0c0-.68,.55-1.24,1.22-1.24s1.22,.55,1.22,1.24-.55,1.24-1.22,1.24-1.22-.55-1.22-1.24h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M288.17,74.59c-.21,0-.39,.18-.39,.39v.64c0,.22,.17,.39,.39,.39s.39-.18,.39-.39v-.64c0-.22-.17-.39-.39-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M288.17,78.16c-.21,0-.39,.18-.39,.39v.64c0,.22,.17,.39,.39,.39s.39-.18,.39-.39v-.64c0-.22-.17-.39-.39-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M288.17,81.72c-.21,0-.39,.18-.39,.39v.64c0,.22,.17,.39,.39,.39s.39-.18,.39-.39v-.64c0-.22-.17-.39-.39-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M288.17,85.28c-.21,0-.39,.18-.39,.39v.64c0,.22,.17,.39,.39,.39s.39-.18,.39-.39v-.64c0-.22-.17-.39-.39-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M288.17,88.85c-.21,0-.39,.18-.39,.39v.65c0,.22,.17,.39,.39,.39s.39-.18,.39-.39v-.65c0-.22-.17-.39-.39-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M288.17,92.42c-.21,0-.39,.18-.39,.39v.64c0,.22,.17,.39,.39,.39s.39-.18,.39-.39v-.64c0-.22-.17-.39-.39-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M292.94,85.91c.52-.02,1.02-.26,1.36-.67l2.93-3.48c1.57,.39,3.15-.58,3.54-2.16,.17-.7,.08-1.45-.25-2.09-.06-.11-.16-.19-.29-.21-.12-.02-.24,.02-.33,.11l-1.47,1.49c-.14,.14-.37,.14-.51,0-.14-.14-.14-.37,0-.52l1.47-1.49c.15-.15,.15-.4,0-.56-.03-.03-.06-.05-.09-.07-1.43-.76-3.19-.21-3.95,1.24-.33,.64-.42,1.38-.25,2.09l-3.44,2.97c-.79,.68-.89,1.88-.21,2.68,.36,.42,.88,.67,1.43,.67,.02,0,.05,0,.07,0h0Zm-1.18-1.94c.01-.31,.15-.6,.39-.8l3.63-3.13c.12-.1,.17-.28,.12-.43-.39-1.13,.19-2.37,1.31-2.76,.38-.14,.8-.16,1.2-.07l-1.05,1.06c-.44,.45-.44,1.18,0,1.63,.44,.45,1.16,.45,1.61,0l1.05-1.06c.27,1.17-.45,2.33-1.61,2.6-.39,.09-.81,.07-1.19-.07-.15-.05-.32,0-.42,.12l-3.09,3.67c-.2,.24-.49,.38-.79,.39-.31,.01-.6-.11-.82-.33-.22-.22-.34-.52-.32-.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M291.94,87.46c-.21,0-.39,.18-.39,.39s.17,.39,.39,.39h5.51c.21,0,.39-.18,.39-.39s-.17-.39-.39-.39h-5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M291.94,89.76c-.21,0-.39,.18-.39,.39s.17,.39,.39,.39h8.67c.21,0,.39-.18,.39-.39s-.17-.39-.39-.39h-8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M294.89,91.95h-2.95c-.21,0-.39,.18-.39,.39s.17,.39,.39,.39h2.95c.21,0,.39-.18,.39-.39s-.17-.39-.39-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M299.03,91.95h-2.44c-.21,0-.39,.18-.39,.39s.17,.39,.39,.39h2.44c.21,0,.39-.18,.39-.39s-.17-.39-.39-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M308.93,80.42h-5.99v-7.17c0-.22-.17-.39-.39-.39h-16.17c-.21,0-.39,.18-.39,.39v22.18c0,.22,.17,.39,.39,.39h16.17c.21,0,.39-.18,.39-.39v-5.97h5.99c.21,0,.39-.18,.39-.39v-8.26c0-.22-.17-.39-.39-.39h0Zm-22.16-6.77h2.63v21.39h-2.63v-21.39h0Zm15.39,21.39h-11.99v-21.39h11.99v6.77h-1.39c-.21,0-.39,.18-.39,.39v8.26c0,.22,.17,.39,.39,.39h1.39v5.58h0Zm6.38-6.36h-7.38v-7.47h7.38v7.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M302.9,84.22c.15,.15,.4,.15,.55,0l1.25-1.27c.15-.15,.16-.4,0-.56s-.4-.16-.55,0c0,0,0,0,0,0l-.98,.99-.32-.33c-.15-.15-.4-.15-.55,0-.15,.15-.15,.39,0,.55l.59,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M305.62,83.82h1.82c.21,0,.39-.18,.39-.39s-.17-.39-.39-.39h-1.82c-.21,0-.39,.18-.39,.39s.17,.39,.39,.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M302.9,86.87c.15,.15,.4,.15,.55,0l1.25-1.27c.14-.16,.13-.41-.03-.56-.15-.14-.37-.14-.52,0l-.98,.99-.32-.33c-.15-.15-.4-.15-.55,0-.15,.15-.15,.4,0,.56l.6,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M305.62,86.47h1.82c.21,0,.39-.18,.39-.39s-.17-.39-.39-.39h-1.82c-.21,0-.39,.18-.39,.39s.17,.39,.39,.39h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimsInfographic);
export default __webpack_public_path__ + "static/media/LimsInfographic.e43d29f5b9b645d2dba722c2cf1a0bee.svg";
export { ForwardRef as ReactComponent };